<template>
<nav class="c-m-company-menu" id="company-menu">
    <div class="c-m-company-menu__list">

        <a v-for="item in menu_items" class="c-m-company-menu__item" :id="`menu-item-${item.id}`" @click="scrollTo(item.id)">
            <icon :icon="item.icon"></icon>
            <span class="c-m-company-menu__name">{{item.name}}</span>
        </a>

    </div>
</nav>
</template>

<script>
import Icon from '../atoms/AtomIcon.vue';

export default {
    props: [
        'menu_items'
    ],
    components: {
        Icon
    },
    data() {
        return {
            sectionRanges: []
        };
    },
    methods: {
        scrollTo: function(target) {
            const scrollPos = document.getElementById(target).offsetTop;
            window.scrollTo({
                top: scrollPos - document.getElementById('company-menu').offsetHeight,
                behavior: 'smooth'
            })
        },
        getRanges: function() {

            return this.menu_items.map(item => {
                const elem = document.getElementById(item.id);
                let top = elem ? elem.offsetTop : null;
                let bottom = document.getElementById(item.id).offsetTop + document.getElementById(item.id).scrollHeight;

                return {
                    'top': top,
                    'bottom': bottom,
                    'id': item.id
                };
            })

        },
        highlightMenu: function() {
            let menu = document.getElementById('company-menu');
            document.getElementsByClassName('c-m-company-menu__item')[0].classList.add('c-m-company-menu__item--active')

            window.addEventListener('scroll', () => {

                let menuPos = menu.offsetTop;

                for (let i = 0; i < this.sectionRanges.length; i++) {
                    let item = document.getElementById(`menu-item-${this.sectionRanges[i].id}`);
                    if (menuPos >= this.sectionRanges[i].top - menu.offsetHeight && menuPos <= this.sectionRanges[i].bottom - menu.offsetHeight) {
                        item.classList.add('c-m-company-menu__item--active');
                    } else if(item.classList.contains('c-m-company-menu__item--active')) {
                        item.classList.remove('c-m-company-menu__item--active');
                    }
                }
            })
        }
    },
    mounted() {
        this.sectionRanges = this.getRanges();

        let resizeTimer;
        window.addEventListener('resize', () => {

            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                this.sectionRanges = this.getRanges();
            }, 250);

        });

        this.highlightMenu();
    }
}
</script>



// WEBPACK FOOTER //
// src/views/components/molecules/MoleculeCompanyMenu.vue